// @ts-check
import React, { useState, useRef } from 'react';
import * as _ from 'lodash';

// components
import CommonModal from '../modals/common/Modal';
import { Confirmation } from '../modals/common';

// services
import SessionStorageService from '../../services/utilities/SessionStorageService';
import LocalStorageService from '../../services/utilities/LocalStorageService';
import DirectApiSettingsApi from '../../services/DirectApiSettings';

// utilities
import { messageUtility } from '../../utilities/messageUtility';
import {
  DIRECT_OAUTH_LINK_DATA,
  DIRECT_REDIRECT_LINK,
  STATUS_CODE,
} from '../../utilities/constants';

// pages
import { useGetReloadExternalServiceCooperationPage } from '../../pages/ExternalServiceCooperation';

// modals
import { DownloadFileErrorDialog } from '../modals/DownloadFileErrorDialog';
import { DirectCommunicationErrorModal } from './DirectCommunicationErrorModal';

export default function DirectRegisterOrganizationGuideModal({
  visible,
  setVisible,
}) {
  const [isShowConfirmModal, setIsShowConfirmModal] = useState(false);
  const [
    isShowDownloadFileErrorModal,
    SetIsShowDownloadFileErrorModal,
  ] = useState(false);
  const [isShowErrorModal, setIsShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const reloadAction = useGetReloadExternalServiceCooperationPage();
  const isSending = useRef(false);

  const create_direct_oauth_link = (
    client_id,
    direct_link_url,
    state,
    nonce
  ) => {
    const result =
      `${DIRECT_OAUTH_LINK_DATA.origin}?` +
      `client_id=${client_id}&` +
      `scope=${DIRECT_OAUTH_LINK_DATA.scope}&` +
      `response_type=${DIRECT_OAUTH_LINK_DATA.response_type}&` +
      `redirect_uri=${direct_link_url}&` +
      `state=${state}&` +
      `nonce=${nonce}&` +
      `prompt=${DIRECT_OAUTH_LINK_DATA.prompt}&` +
      `group_alias=`;
    return result;
  };

  const confirmAction = async () => {
    if (isSending.current) {
      return;
    }
    isSending.current = true;
    try {
      const fieldId = SessionStorageService.getFieldId();
      const {
        data,
        result,
        status,
      } = await DirectApiSettingsApi.authentication_info.fetch(fieldId);
      setIsShowConfirmModal(false);
      if (!result || status === STATUS_CODE.badRequest) {
        setErrorMessage(_.get(data, 'message', null));
        setIsShowErrorModal(true);
        return;
      }
      const client_id = _.get(data, 'entities.client_id', null);
      const link_key = _.get(data, 'entities.link_key', null);
      const state = _.get(data, 'entities.state', null);
      const nonce = _.get(data, 'entities.nonce', null);
      if (
        _.isNull(client_id) ||
        _.isNull(link_key) ||
        _.isNull(state) ||
        _.isNull(nonce)
      ) {
        setIsShowErrorModal(true);
        return;
      }
      const loginId = encodeURIComponent(LocalStorageService.getLoginId());
      const direct_link_url = `${DIRECT_REDIRECT_LINK}/${link_key}/${loginId}`;
      const redirect_url = create_direct_oauth_link(
        client_id,
        direct_link_url,
        state,
        nonce
      );
      window.location.href = redirect_url;
    } catch (error) {
      setVisible(false);
      setIsShowErrorModal(true);
    } finally {
      isSending.current = false;
    }
  };

  const onClose = () => {
    setVisible(false);
    reloadAction();
  };
  const onSubmit = () => {
    setVisible(false);
    setIsShowConfirmModal(true);
  };
  return (
    <React.Fragment>
      <CommonModal
        visible={visible}
        modalClassName={'DirectDescriptionModal--OrganizationGuide'}
      >
        {/* @ts-ignore childrenの型エラーは問題なし */}
        <div className='dialog dialog--modal'>
          <div className='dialog__header'>
            <span className='dialog__title'>
              {messageUtility.getMessage('I-001-535')}
            </span>
          </div>

          <div className='dialog__body'>
            <div className='dialog__text'>
              {messageUtility.getMessage('I-001-536')}
            </div>
          </div>

          <div className='dialog__footer dialog__footer--horizontal'>
            <button className='btn-fixedsize--sub' onClick={onClose}>
              {messageUtility.getMessage('I-000-017')}
            </button>
            <button className='btn-fixedsize--effective' onClick={onSubmit}>
              {messageUtility.getMessage('I-000-080')}
            </button>
          </div>
        </div>
      </CommonModal>
      <Confirmation
        visible={isShowConfirmModal}
        rootClassName={'DirectDescriptionModal--TransitionDirect'}
        title='directの登録画面に移動'
        confirmButtonText={messageUtility.getMessage('I-000-053')}
        cancelButtonText={messageUtility.getMessage('I-000-008')}
        message={
          <React.Fragment>
            {messageUtility.getMessage('I-001-540')}
          </React.Fragment>
        }
        onConfirm={confirmAction}
        onCancel={() => {
          setIsShowConfirmModal(false);
          setVisible(true);
        }}
        tabFocus={true}
      />
      <DownloadFileErrorDialog
        visible={isShowDownloadFileErrorModal}
        onClose={() => {
          SetIsShowDownloadFileErrorModal(false);
        }}
      />
      <DirectCommunicationErrorModal
        visible={isShowErrorModal}
        setVisible={setIsShowErrorModal}
        errorMessage={errorMessage}
        closeAction={reloadAction}
      />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/externalService/DirectRegisterOrganizationGuideModal.jsx